import { create, read, update } from '@/api/rest';

/**
 * @module api/request
 */
const request = {
  index: async (params) => await read(`/request?` + params.toString()),
  view: async (id, params) => await read(`/request/${id}?` + params.toString()),
  new: async (type) => await read(`/request/new/${type}`),
  count: async (role) => await read(`/request/count/${role}`),
  create: async (data) => await create(`/request`, data),
  partnerUpdate: async (id, data) =>
    await update(`/request/partner-update/${id}`, data),
  moderatorUpdate: async (id, data) =>
    await update(`/request/moderator-update/${id}`, data),
};
export default request;
